export default __webpack_public_path__ + "776a22f4b90bbe4dfe85ceca731e1904.svg";